/** These tables disagree with ShipData.cs on purpose; which side wins and why is in
 * docs/06-parity.md. Presentation follows the client, authority follows the server. */
export const SHIP_SCALE_LEGACY_CLIENT: readonly number[] = [
  0.9, 1.1, 1.1, 1.3, 1.3, 1.3, 1.3, 1.7, 1.5, 1.6, 1.5, 1.5, 1.5, 1.5, 1.5, 1.6, 2.3, 2.4, 2.5,
  2.6, 2.7, 3.5,
];

export const SHIP_SCALE_SERVER: readonly number[] = [
  0.9, 1.1, 1.1, 1.3, 1.3, 1.3, 1.3, 1.7, 1.5, 1.6, 1.5, 1.5, 1.5, 1.5, 1.5, 1.6, 2.3, 2.4, 2.5,
  2.6, 2.7, 2.8,
];

export const VIEWPORT_SCALE: readonly number[] = [
  0.9, 1.1, 1.1, 1.3, 1.3, 1.3, 1.3, 1.7, 1.5, 1.6, 1.5, 1.5, 1.5, 1.5, 1.5, 1.6, 2.3, 2.4, 2.5,
  2.6, 2.7, 2.8,
];

export function shipScale(shipId: number): number {
  return SHIP_SCALE_LEGACY_CLIENT[shipId] ?? 1;
}

export function viewportScale(shipId: number): number {
  return VIEWPORT_SCALE[shipId] ?? 1;
}

export const SHIP_NAMES: readonly string[] = [
  'Base Fighter',
  'Support',
  'Utility',
  'Heavy',
  'Healer',
  'M.o.D',
  'Sniper',
  'Engi',
  'Bruiser',
  'Frigate',
  'The Doctor',
  'Mechanic',
  'D.o.D',
  'aLeRT',
  'Stealth',
  'Shogun',
  'The Moth',
  'Suicide Squad',
  'Bully',
  'Wurship',
  'B.R.U.C.E',
  'The Wall',
];

export function shipName(shipId: number): string {
  return SHIP_NAMES[shipId] ?? `Ship ${String(shipId)}`;
}

export const MAGNET = {
  serverBaseRadius: 95,
  serverRadiusBonus: 20,
  legacyClientRadius: 80,
  legacyRingInset: 20,
} as const;

/** Used for client-side prediction only, so the client agrees with what the server actually collects. */
export function serverMagnetRadius(shipId: number): number {
  const scale = (1 + shipScale(shipId)) / 2;
  return MAGNET.serverBaseRadius * scale + MAGNET.serverRadiusBonus;
}

export function legacyClientMagnetRadius(shipId: number): number {
  const scale = (1 + shipScale(shipId)) / 2;
  return MAGNET.legacyClientRadius * scale;
}

export function legacyDrawnMagnetRadius(shipId: number): number {
  return legacyClientMagnetRadius(shipId) - MAGNET.legacyRingInset;
}

export const CLIENT_TO_SERVER_UPGRADE_ID: readonly number[] = [
  -1, 1, 2, 3, 28, 16, 4, 5, 6, 7, 0, 8, 9, 10, 11, 12, 13, 17, 18, 19, 20, 21, 22, 23, 15, 26, 27,
  14, 24, 25,
];

export function serverUpgradeId(clientUpgradeId: number): number {
  return CLIENT_TO_SERVER_UPGRADE_ID[clientUpgradeId] ?? -1;
}

export const LEGACY_ABILITY_COST: readonly number[] = [
  0, 0, 0, 0, 0, 250, 0, 100, 0, 0, 0, 200, 250, 250, 0, 100, 100, 100, 0, 0, 0, 0,
];

export const SHIP_TIERS: readonly number[] = [
  0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3,
];

export const TIER_COSTS: readonly number[] = [1500, 2500, 4000, 7000];

export const UPGRADE_COST_BASE = 35;

export const MAX_UPGRADE_LEVEL = 7;
export const MAX_SHIP_TIER = 3;

export function upgradeCost(tier: number, level: number): number {
  return Math.floor(1.5 ** tier * 1.5 ** level * UPGRADE_COST_BASE);
}
